module.exports = require("./hu-HU");